module.exports = __webpack_public_path__ + "img/75760.87cdc1c9.svg";